import React,{useState,useEffect} from 'react'
import { URL } from '../../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { invokeServices } from '../../ServiceCalls/ApiCalls';
import './Services.css'


function ServicesComponent() {
    
    const navigate = useNavigate()

    const[services,setServices] = useState([])
    const[serviceName,setServiceName] = useState('')
    const[serviceDesc,setServiceDesc] = useState('')
    const[serviceid,setServiceId] = useState('')
    const[rowid,setRowId]= useState('')
    const[status,setStatus]=useState(false)
    const[isLoading,setIsLoading] = useState(true)
    const[isRefreshing,setIsRefreshing] = useState(false)
    const[createService,setCreateService] = useState({
        service_name:'',
        service_desc:''
    })

    useEffect(() =>{
        if(!localStorage.getItem('user')){
            navigate('/')
        }
        async function GetData(){
            setIsLoading(true);
            try {
                const services_list = await invokeServices()
                setServices(services_list)
            } catch (error) {
                console.error('Error fetching services:', error);
                toast.error('Failed to load services', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } finally {
                setIsLoading(false);
            }
        }
    
        GetData()
    },[])

    const refreshServices = async () => {
        setIsRefreshing(true);
        try {
          const services_list = await invokeServices()
          setServices(services_list)
          
          toast.success('Services refreshed successfully!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } catch (error) {
          console.error('Error refreshing services:', error);
          toast.error('Failed to refresh services', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } finally {
          setIsRefreshing(false);
        }
    };

    const handleAddServices = (e) => {
        const{name,value} = e.target;
        setCreateService({...createService,[name]:value})
    }
    const options = (method = "GET",body) =>{
        return {
            method,
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        }
    }
    const handleSubmitServices = async(e) => {

        e.preventDefault()

        try {
            const add_services_response = await fetch(`${URL}` + '/services/addservice',options("POST",createService));
            const services_data = await add_services_response.json();

            if(add_services_response.ok){
                //alert('Term Dates Added !!')
                setServices([...services,services_data])
                toast.success('🦄 Wow Service Added!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                reset()
            }
            else{
                //alert('Add TermDates Failed...')
                toast.error('🦄 OOps Add Service Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleServiceChange = e =>{
        const{name,value} = e.target;

        if(name === 'service_name'){
            setServiceName(value)
        }
        if(name === 'service_desc'){
            setServiceDesc(value)
        }
    }
    const reset = (e) => {
        e.preventDefault()
        setCreateService({
            service_name:'',
            service_desc:''
        })
    }
    const handleEditService = (s,rid) => {
        setServiceName(s.service_name)
        setServiceDesc(s.service_desc)
        setServiceId(s._id)
        setRowId(rid)
        setStatus(false)
    }
    const handleUpdateService = async() => {
        try {
            const update_services_response = await fetch(`${URL}` + '/services/'+`${serviceid}`,options("PATCH",{service_name:serviceName,service_desc:serviceDesc}));

            if(update_services_response.ok){
                const update_services_status = await update_services_response.json();
                const dataUpdate = [...services]
                dataUpdate[rowid] = update_services_status;
                setServices([...dataUpdate])
                setStatus(true)
                //toggleRow(rowid)
                toast.success('🦄 Wow Row Updated!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else{
               // alert('Update Failed')
               toast.error('🦄 OOps Update Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
    
        } catch (error) {
            console.log(error)
        }
    }
    const deleteServices = async(tr_id,rowid) => {

        if(!window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`))
            return;

        try{
            const delete_services_response = await fetch(`${URL}` + '/services/'+`${tr_id}`, options("DELETE"));
            if(delete_services_response.ok){
               // alert(`TermDate at ${rowid+1}  is Deleted !!`)
                const dataDelete = [...services];
                dataDelete.splice(rowid,1)
                setServices([...dataDelete])
                toast.success('🦄 Wow Services Deleted!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
    
            }
            else{
                toast.error('🦄 OOps Service Del Failed!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        }catch(err){
            console.log(err)
        }
      }
    const handleReset = () => {
        setStatus(false)
    }
  return (
    <div className="admin-panel">
        <div className='container admin-container'>
            <div className="row mt-5">
              <div className="col-md-12 col-sm-12">
                <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h3 className="mb-1">
                      <i className="fa fa-cogs text-warning me-2"></i>
                      Manage Services ({services.length})
                    </h3>
                    <p className="text-muted">Add new services and manage existing service records</p>
                  </div>
                  <div className="failed-bookings-actions">
                    <button 
                      className="btn btn-outline-secondary me-2"
                      onClick={refreshServices}
                      disabled={isRefreshing}
                    >
                      {isRefreshing ? (
                        <>
                          <i className="fa fa-spinner fa-spin me-1"></i>
                          Refreshing...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh me-1"></i>
                          Refresh
                        </>
                      )}
                    </button>
                    <button 
                      className="btn btn-primary"
                      onClick={() => navigate('/user')}
                    >
                      <i className="fa fa-arrow-left me-1"></i>
                      Back to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Add Service Section */}
            <div className="row mb-5">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-plus-circle text-primary me-2"></i>
                    Add New Service
                  </h4>
                </div>
                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <form onSubmit={handleSubmitServices}>
                      <div className="mb-3">
                          <label htmlFor="service_name" className="form-label">Service Name</label>
                          <input 
                            type="text" 
                            className="form-control" 
                            id="service_name" 
                            name="service_name"
                            value={createService.service_name}
                            onChange={e => handleAddServices(e)} 
                            required
                            placeholder="Enter Service Name" autoComplete='off'/>
                      </div>
                      <div className="mb-3">
                          <label htmlFor="service_desc" className="form-label">Service Description</label>
                          <textarea 
                            className="form-control" 
                            id="service_desc" 
                            name="service_desc"
                            rows={5}
                            value={createService.service_desc} 
                            onChange={e => handleAddServices(e)} 
                            required
                            placeholder="Enter Service Description" autoComplete='off'/>
                      </div>
                      <div className="d-flex gap-2">
                        <button 
                          type="submit" 
                          className="btn btn-primary">
                          <i className="fa fa-plus me-1"></i>
                          Add Service
                        </button>
                        <button 
                          onClick={e => reset(e)}
                          className="btn btn-outline-secondary">
                          <i className="fa fa-refresh me-1"></i>
                          Reset
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* Existing Services Section */}
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="mb-0">
                    <i className="fa fa-list text-warning me-2"></i>
                    Existing Services
                  </h4>
                </div>
                
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="text-center">
                      <div className="spinner-border text-warning" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3 text-muted">Loading services...</p>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className='table table-bordered table-hover'>
                        <thead className="table-warning text-center">
                            <tr>
                                <th className='text-center'>S.No</th>
                                <th className='text-center'>Service Name</th>
                                <th className='text-center'>Description</th>
                                <th className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                services.length > 0 ?
                                services.map((s,idx) =><tr key={idx}>
                                    <td className="text-center">{idx+1}</td>
                                    <td>{s.service_name}</td>
                                    <td>{s.service_desc ? s.service_desc.substring(0, 100) + (s.service_desc.length > 100 ? '...' : '') : 'No description'}</td>
                                    <td className="text-center">
                                        <div className="btn-group" role="group">
                                          <button 
                                            className="btn btn-outline-primary btn-sm"
                                            data-bs-toggle="modal"
                                            data-bs-target="#editModalPop"
                                            onClick={() => handleEditService(s,idx)}
                                            title="Edit Service"
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </button>
                                          <button 
                                            onClick={() => deleteServices(s._id,idx)}
                                            className="btn btn-outline-danger btn-sm"
                                            title="Delete Service"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </div>
                                    </td>
                                </tr>)
                                :
                                <tr>
                                    <td colSpan={4} className="text-center text-muted py-4">
                                      <i className="fa fa-cogs fa-2x mb-2 d-block text-muted"></i>
                                      No services found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
        </div>
        <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false"  id="editModalPop">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="staticBackdropLabel">Edit Services</h5>
                                    <button 
                                        type="button" 
                                        className="btn-close" 
                                        data-bs-dismiss="modal" 
                                        //onClick={() => handleReset()} 
                                        aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    {
                                        status ? 
                                            <div className="container">
                                                <div className="row my-3">
                                                    <div className="col-md-12 col-sm-12 d-flex flex-column justify-content-center border-1">
                                                         <div className="success-img"></div>
                                                        <h4 className="text-success text-center m-3">Row Updated Successfully !!!</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="container">
                                            <div className="row my-3">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="service_name" className="small"><strong>Service</strong></label>
                                                    <input 
                                                        type="text"
                                                        className='form-control service'
                                                        name="service_name"
                                                        value={serviceName}
                                                        onChange={e => handleServiceChange(e)}
                                                        autoComplete='off'
                                                        id="service_name" />
                                                </div>  
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <label htmlFor="service_desc" className="small"><strong>Service Desc</strong></label>
                                                    <textarea 
                                                        name="service_desc"
                                                        className='form-control service'
                                                        id="service_desc"
                                                        rows={5}
                                                        value={serviceDesc}
                                                        autoComplete='off'
                                                        onChange = {e => handleServiceChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                   
                                </div>
                                <div className="modal-footer">
                                    {/* <button 
                                        type="button" 
                                        className="btn btn-secondary"
                                        onClick={() => handleReset()} 
                                        data-bs-dismiss="modal">Close</button> */}
                                    {
                                        status ? 
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary"
                                            //onClick={() => handleReset()} 
                                            data-bs-dismiss="modal">Close</button>
                                        :
                                        <button 
                                            onClick={() => handleUpdateService()}
                                            type="button" 
                                            className="btn btn-primary">Update</button>
                                    }
                                    
                                </div>
                            </div>
                        </div>
             
                </div>
        <ToastContainer/>
    </div>
  )
}

export default ServicesComponent